<div class="flex-container flex-center align-items icon-button" [ngClass]="buttonClasses">
    <div class="flex-container flex-center align-items pane" (click)="onClick($event)">
        <mat-icon *ngIf="!imgSrc" [color]="color" [ngClass]="{'mat-secondary':!color}">
            <ng-content></ng-content>
        </mat-icon>
        <img *ngIf="imgSrc" [src]="imgSrc" />
    </div>
</div>
